import { isRecruiting } from "@/lib/workspace";

export default function BrandFooter() {
  return (
    <footer className="mt-auto bg-[#15233B] text-white relative overflow-hidden">
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.06] bg-[radial-gradient(circle_at_20%_50%,#FFCB05_0,transparent_45%),radial-gradient(circle_at_80%_50%,#1E73C9_0,transparent_50%)]"
      />
      <div className="h-[3px] bg-gradient-to-r from-transparent via-[#FFCB05] to-transparent" />
      <div className="px-4 sm:px-6 lg:px-8 py-5 flex items-center gap-3 text-[10px] uppercase tracking-[0.25em] text-white/55 relative">
        <div className="h-7 w-7 rounded-md bg-white grid place-items-center p-0.5 ring-1 ring-[#FFCB05]/40">
          <img src="/brand/avida-logo.png" alt="Avida" className="h-full w-auto" />
        </div>
        <span className="hidden sm:inline">Avida Personal Care · Avida Healthcare Software Solutions</span>
        <span className="ml-auto inline-flex items-center gap-1.5 font-bold text-[#FFCB05]">
          <span className="h-1.5 w-1.5 rounded-full bg-[#FFCB05]" /> {isRecruiting() ? "Recruiting" : "Intake"} Pipeline
        </span>
      </div>
    </footer>
  );
}
